import { render, staticRenderFns } from "./PageEmailConfirmation.vue?vue&type=template&id=13923a41"
import script from "./PageEmailConfirmation.vue?vue&type=script&lang=js"
export * from "./PageEmailConfirmation.vue?vue&type=script&lang=js"
import style0 from "./PageEmailConfirmation.vue?vue&type=style&index=0&id=13923a41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports